import { render } from "./MainTypeOfUsers.vue?vue&type=template&id=0ec868d9&scoped=true"
import script from "./MainTypeOfUsers.vue?vue&type=script&lang=js"
export * from "./MainTypeOfUsers.vue?vue&type=script&lang=js"

import "./MainTypeOfUsers.vue?vue&type=style&index=0&id=0ec868d9&scoped=true&lang=css"

import exportComponent from "D:\\ERP SISTEMA POS\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ec868d9"]])

export default __exports__